<mat-form-field appearance="outline">
  <mat-label>Магазин</mat-label>
  <mat-select [formControl]="control">
    <mat-option *ngFor="let eshop of eshops" [value]="eshop">
      {{ eshop?.description }}
    </mat-option>
    <mat-option (click)="create()"> Создать </mat-option>
  </mat-select>
</mat-form-field>
